import { FC, useMemo } from 'react';

import { isMatchGateway } from 'cashout/helpers/utils';

import { RestrictedCountries } from 'deposit/services/types';

import { NavBar } from 'common/components';
import ApImage from 'common/components/ap-image/ap-image';
import Footer from 'common/components/footer/footer';
import AppLayout from 'common/components/layouts/app-layout';
import CustomHeader from 'common/components/layouts/custom-header/custom-header';
import { translateCustomParams } from 'common/config/i18n';
import { useAppSelector } from 'common/helpers/hooks';
import ExternalRedirection from 'common/helpers/new-tab-delayed-redirection';
import { getPaymentMethodImage } from 'common/helpers/url';
import { getDeposit, getMerchant, getPaymentMethod } from 'common/store/deposit';

const DepositLayout: FC = ({ children }) => {
  const deposit = useAppSelector(getDeposit);
  const merchant = useAppSelector(getMerchant);

  return (
    <ExternalRedirection>
      <AppLayout CustomNavBar={DepositNavBar} CustomFooter={DepositFooter}>
        <CustomHeader
          title="AstroPay OneTouch - Deposit"
          description={translateCustomParams('one_touch_operation_complete', {
            '{amount}': `${deposit.currency} ${deposit.amount}`,
            '{merchantName}': merchant.name,
            '{merchantOperation}': merchant.merchantOperation,
          })}
        />
        {children}
      </AppLayout>
    </ExternalRedirection>
  );
};

const DepositNavBar: FC = () => {
  const deposit = useAppSelector(getDeposit);
  const paymentMethod = useAppSelector(getPaymentMethod);
  const isGateway = isMatchGateway();
  const showByAstro = useMemo(() => {
    return (
      paymentMethod &&
      paymentMethod.payByAstropay &&
      deposit.paymentMethodCode === paymentMethod.code
    );
  }, [paymentMethod, deposit]);
  const restrictedCountry = Object.values(RestrictedCountries).includes(
    deposit.country as RestrictedCountries,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const NavBarBrandInfo = () => {
    if (showByAstro && deposit.paymentMethodCode && !restrictedCountry && !isGateway) {
      return (
        <ApImage
          src={getPaymentMethodImage(deposit.paymentMethodCode)}
          alt={deposit.paymentMethodName ?? deposit.paymentMethodCode}
          style={{ maxWidth: '50px' }}
        />
      );
    }
    return null;
  };
  return <NavBar />;
};

const DepositFooter: FC = () => {
  const deposit = useAppSelector(getDeposit);
  return !['NO'].includes(deposit.country) ? null : <Footer />;
};

export default DepositLayout;
